import { Badge } from '@mantine/core';
import { useActivityAttentionCount } from '../controllers/ActivityBadgeController';

/**
 * Бейдж для dock-кнопки Activity: показывает число тредов, где у текущего
 * пользователя есть непрочитанные адресованные сообщения (mention,
 * assignment). Скрыт при нулевом счётчике.
 *
 * Данные — из ActivityBadgeController (singleton с WS-подпиской).
 */
export function ActivityDockBadge() {
  const count = useActivityAttentionCount();
  if (count <= 0) return null;

  return (
    <Badge
      size='sm'
      color='red'
      variant='filled'
      aria-label={`${count} адресованных мне тредов с непрочитанными`}
    >
      {count > 99 ? '99+' : count}
    </Badge>
  );
}
